import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { CountryItem, LogisticService } from '../../../services/logistic.service';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-valuta',
  templateUrl: './valuta.component.html',
  styleUrls: ['./valuta.component.css']
})
export class ValutaComponent implements OnInit {
    public valutaId: string;

    public selectedBgValuta: string = 'BASIC';

    public edit?: Edit;

    public selectListRoundOff: RoundOffItem[] = [];

    public selectListCountries: CountryItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private utility: UtilityService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.valutaId = this.stateService.getStateParams()['valuta_id'];
    }

    private async loadEdit() {
        if (!!this.valutaId) {
            this.edit = (await this.datatask.Post(656, { valuta_id: this.valutaId }))[0];
        }
    }
    
    private async loadRoundOff() {
        this.selectListRoundOff = await this.datatask.Post(742);
    }

    private async loadCountries() {
        this.selectListCountries = await this.logistic.getCountries();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(743, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private recalcValuta() {
        if (!!this.edit) {
            this.edit.valuta_exchangefactor = this.utility.parseNumber(this.edit.valuta_exchangerate) / this.utility.parseNumber(this.edit.valuta_pr);
        }
    }

    public onChanged(_: number, id: keyof Edit) {
        switch (id) {
            case 'valuta_exchangerate':
            case 'valuta_pr':
                this.recalcValuta();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadRoundOff();
        this.loadCountries();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    valuta_id: string;
    valuta_name: string;
    valuta_pr: number;
    country_id: string;
    fci: number;
    valuta_code: number;
    valuta_code_factoring: number;
    valuta_exchangerate: number;
    valuta_exchangefactor: number;
    round_off: string;
    is_new: string;
    isbasecurrency: number;
}

interface RoundOffItem {
    roundoff_id: string;
    roundoff_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('valuta', {
//        templateUrl: 'views/components/views/valuta/valuta.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'valutaService', 'logisticService', 'economyService', 'layoutService', function ($stateParams, stateService, utilityService, valutaService, logisticService, economyService, layoutService) {
//            const vm = this;
//            let valutaId = $stateParams.valuta_id;

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                valutaId: valutaId,
//                bgValuta: {
//                    selected: 'BASIC',
//                    buttons: [
//                        { id: 'BASIC', label: 'valuta_basic', color: 'primary', onClick: function () { vm.model.bgValuta.selected = 'BASIC'; } },
//                        { id: 'OTHER', label: 'valuta_other', color: 'primary', onClick: function () { vm.model.bgValuta.selected = 'OTHER'; } }
//                    ]
//                },
//                edit: {},
//                selectListCountries: [],
//                selectListRoundOff: []
//            };

//            async function loadValutaEdit() {
//                vm.model.edit = (await valutaService.getValutaEdit({ valuta_id: valutaId }))[0];
//            }

//            async function loadCountries() {
//                vm.model.selectListCountries = await logisticService.listCountries();
//            }

//            async function loadRoundOff() {
//                vm.model.selectListRoundOff = await economyService.listRoundOff();
//            }

//            function recalcValuta() {
//                vm.model.edit.valuta_exchangefactor = (utilityService.parseNumber(vm.model.edit.valuta_exchangerate) / utilityService.parseNumber(vm.model.edit.valuta_pr));
//            }

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'valuta_exchangerate':
//                    case 'valuta_pr':
//                        if (utilityService.validateWatchValue(value, vm.model.edit[id]) !== true) return;

//                        vm.model.edit[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        recalcValuta();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            vm.selectBgValuta = function (item) {
//                vm.model.bgValuta.selected = item;
//            };

//            vm.saveChanges = function () {
//                valutaService.saveObj(vm.model.edit).then(function () {
//                    stateService.back();
//                });
//            };

//            vm.$onInit = function () {
//                loadValutaEdit();
//                loadCountries();
//                loadRoundOff();
//            }
//        }]
//    });
//})();
